import React, { useContext, useState, useEffect, useCallback } from 'react';
import { VarContext } from '../Context/VarContext';
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faEdit, faTrash, faSave, faUpload, faDownload, faFileArrowDown, faFileExport } from '@fortawesome/free-solid-svg-icons'
import { faEyeSlash, faEye, faSpinner, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'

import '../fonts/fonts.css'
import './Login.css';

import ResetPassword from './ResetPassword';

import * as Img from '../Components/Imagenes'
//import Nav from '../Components/Nav'

// Imágenes de usuario/login
import imgCorreo from '../user/correo.png';
import imgLogoFemsa from '../user/logo_femsa.svg';
import imgLogoMirc from '../user/logo_mirc.svg';
import imgIlustracion from '../user/imagen1.png';

// Encriptar contraseñas
//import bcrypt from 'bcryptjs';

const Login = ({ props }) => {
	const GConText = useContext(VarContext);
	const navigate = useNavigate();


	//PARA DETECTAR EL TEMA DE REINICIAR EL PASSWORD
	const [showResetPassword, setShowResetPassword] = useState(false);
	const [resetToken, setResetToken] = useState('');

	// 2FA states
	const [show2FA, setShow2FA] = useState(false);
	const [twoFactorKey, setTwoFactorKey] = useState('');
	const [twoFactorEmail, setTwoFactorEmail] = useState('');
	const [twoFactorCode, setTwoFactorCode] = useState('');
	const [twoFactorError, setTwoFactorError] = useState('');
	const [twoFactorLoading, setTwoFactorLoading] = useState(false);

	useEffect(() => {
	const urlParams = new URLSearchParams(window.location.search);
	const token = urlParams.get('token');
	if (token) {
		setShowResetPassword(true);  // Mostrar reset password
		setResetToken(token);        // Guardar el token
	}
	}, []);
	//------------------------


	// ✨ Estado para evitar flash de login
	const [isCheckingAuth, setIsCheckingAuth] = useState(true);

	// ✨ Optimización 6: Log helper para producción
	const log = GConText.logs ? console.log : () => { };
	const logError = GConText.logs ? console.error : () => { };

	// ✨ Función centralizada para redirección
	const redirectUser = useCallback((userType) => {
		const routes = {
			'admin': '/admin',
			'user': '/dashboard'
		};

		//const route = routes[userType] || '/introduccion'; // Default a usuario normal
		//navigate(route, { replace: true }); // replace: true evita volver atrás

		//mas eficiente
		navigate(routes[userType] || '/dashboard', { replace: true });

	}, [navigate]);

	const [loginAttempts, setLoginAttempts] = useState(0);

	const [errorLogin, setErrorLogin] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const [isBlocked, setIsBlocked] = useState(false);
	const [blockMessage, setBlockMessage] = useState('');
	const MAX_ATTEMPTS = 5;

	const userInput = React.useRef();
	const passInput = React.useRef();


	/* const UserChange = (event) => {
		log(event.target.value);
		//setNombre(event.target.value);
		GConText.setUsername(event.target.value.toLowerCase());
	} */

	/* const PassChange = (event) => {
		log(event.target.value);
		//setNombre(event.target.value);
		GConText.setPassword(event.target.value);
	} */

	// ✨ Usar estado local para validación inmediata
	const [formData, setFormData] = useState({ username: '', password: '' });
	const [isFormValid, setIsFormValid] = useState(false);

	const UserChange = (event) => {
		const username = event.target.value.toLowerCase();
		const newFormData = { ...formData, username };

		setFormData(newFormData);
		GConText.setUsername(username);

		// Validación inmediata con datos locales
		const isValid = username.length >= 3 && (newFormData.password || '').length >= 6;
		setIsFormValid(isValid);
	};

	const PassChange = (event) => {
		const password = event.target.value;
		const newFormData = { ...formData, password };

		setFormData(newFormData);
		GConText.setPassword(password);

		// Validación inmediata con datos locales
		const isValid = (newFormData.username || '').length >= 3 && password.length >= 6;
		setIsFormValid(isValid);
	};

	const setTimeoutImg = () => {
		//setVerImg(true)
		setTimeout(() => {
			//setVerImg(false)
			//setPass(false)
			//setUser(false)
			setErrorLogin(false)

		}, 4000);
	}

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			chkLogin();
			log('do validate')
		}
	}

	// Validación de entrada para prevenir XSS
	const validateInput = (input) => {
		return input.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
	};


	const API_BASE = process.env.REACT_APP_API_BASE;
	log(API_BASE); // Debe mostrar la URL correcta

	//PRODUCTIVO
	// Refresca el accessToken usando el refreshToken (cookie httpOnly)
	const refreshAccessToken = useCallback(async () => {
		try {
			const res = await fetch(`${API_BASE}/refresh`, {
				method: 'POST',
				credentials: 'include'
			});
			if (!res.ok) return false;
			const data = await res.json();
			if (data.accessToken) {
				sessionStorage.setItem('accessToken', data.accessToken);
				return true;
			}
			return false;
		} catch (err) {
			return false;
		}
	}, [API_BASE]);

	// Debug
	/* const refreshAccessToken = async () => {
	try {
		// Obtener refreshToken del localStorage
		const refreshToken = localStorage.getItem('refreshToken');
		if (!refreshToken) return false;

		const res = await fetch(`${API_BASE}/refresh`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ refreshToken }), // Enviar en el body
		credentials: 'include'
		});
		
		if (!res.ok) return false;
		const data = await res.json();
		if (data.accessToken) {
		sessionStorage.setItem('accessToken', data.accessToken);
		return true;
		}
		return false;
	} catch (err) {
		return false;
	}
	}; */



	// Wrapper para llamadas protegidas que renueva el accessToken si expira
	const apiFetch = useCallback(async (path, opts = {}) => {
		const token = sessionStorage.getItem('accessToken');
		const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
		if (token) headers['Authorization'] = `Bearer ${token}`;

		let res = await fetch(`${API_BASE}${path}`, {
			...opts,
			headers,
			credentials: 'include'
		});

		if (res.status === 401) {
			const ok = await refreshAccessToken();
			if (!ok) throw new Error('Not authenticated');
			const newToken = sessionStorage.getItem('accessToken');
			headers['Authorization'] = `Bearer ${newToken}`;
			res = await fetch(`${API_BASE}${path}`, {
				...opts,
				headers,
				credentials: 'include'
			});
		}

		return res;
	}, [API_BASE, refreshAccessToken]);

	/* const obtenerPerfil = async () => {
	const token = sessionStorage.getItem('accessToken');
	const res = await fetch(`${API_BASE}/perfil`, {
		method: 'GET',
		headers: { 'Authorization': `Bearer ${token}` },
		credentials: 'include'
	});
	if (!res.ok) throw new Error('No autenticado');
	return await res.json();
	}; */

	const obtenerPerfil = useCallback(async () => {
		const res = await apiFetch('/perfil', { method: 'GET' });
		if (!res.ok) throw new Error('No autenticado');
		return await res.json();
	}, [apiFetch]);

	const [isLoading, setIsLoading] = useState(false);

	const chkLogin = async () => {

		// Prevenir múltiples ejecuciones
		if (isLoading) {
			log('Login ya en progreso, ignorando...');
			return;
		}

		if (loginAttempts >= MAX_ATTEMPTS) {
			//alert('Has superado el número máximo de intentos. Intenta más tarde.');
			//setTimeout(() => setLoginAttempts(0), 300000); // 5 minutos
			setIsBlocked(true);
			setBlockMessage('Has superado el número máximo de intentos. Intenta más tarde.');
			setTimeout(() => {
				setLoginAttempts(0);
				setIsBlocked(false);
				setBlockMessage('');
			}, 300000); // 5 minutos
			return;
		}

		log('=== INICIANDO LOGIN ===', new Date().toISOString());
		setIsLoading(true); // ← Activar loading


		// Sanitizar los datos antes de usarlos
		const usernameSanitized = validateInput(GConText.username);
		//const passwordSanitized = validateInput(GConText.password);
		const passwordSanitized = GConText.password; // No sanitizar la contraseña

		log("🚀 ~ usernameSanitized:", usernameSanitized)
		log("🚀 ~ passwordSanitized", passwordSanitized)

		// ✨ Crear AbortController para timeout
		const controller = new AbortController();
		const timeoutId = setTimeout(() => {
			controller.abort();
			log('⏰ Login timeout - cancelando petición');
		}, 10000); // 10 segundos timeout


		//console.time('⏱️ Login total');
		//console.time('🌐 Fetch request');

		try {
			const res = await fetch(`${API_BASE}/login`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					username: usernameSanitized,
					password: passwordSanitized,
					includeProfile: true // ✨ Pedir perfil en la misma llamada
				}),
				credentials: 'include',
				signal: controller.signal // ✨ Agregar signal para timeout
			});

			// ✨ Limpiar timeout si la petición fue exitosa
			clearTimeout(timeoutId);

			if (!res.ok) {
				setErrorLogin(true);

				// 423 Locked: la cuenta quedó bloqueada por intentos fallidos
				// (norma FEMSA). Hay que decirle al usuario cuánto esperar,
				// si no queda atrapado sin entender por qué.
				let message = 'No se puede iniciar sesión, por favor verifica tu usuario y contraseña.';
				if (res.status === 423) {
					try {
						const lockData = await res.json();
						if (lockData && lockData.error) message = lockData.error;
					} catch (e) { /* respuesta sin JSON: se usa el mensaje genérico */ }
				}

				setErrorMessage(message);
				setLoginAttempts(loginAttempts + 1);
				//clearPass();
				setTimeoutImg();
				return;
			}

			//console.timeEnd('🌐 Fetch request');
			//console.time('📦 JSON parse');
			const data = await res.json();

			// Si requiere 2FA, mostrar pantalla de código
			if (data.requires2FA) {
				setTwoFactorKey(data.twoFactorKey);
				setTwoFactorEmail(data.email || '');
				setTwoFactorCode('');
				setTwoFactorError('');
				setShow2FA(true);
				return;
			}

			//console.timeEnd('📦 JSON parse');
			//console.timeEnd('⏱️ Login total');

			//log("🚀 ~ data:", data)

			// ✨ Verificar si el backend devuelve el perfil
			if (data.user) {
				log("🚀 ~ si existe user:", data.user);
				// ✅ OPTIMIZADO: Una sola llamada con token Y perfil
				sessionStorage.setItem('accessToken', data.accessToken);

				// Guardar datos directamente sin llamada adicional
				GConText.setUserId(data.user.id);
				GConText.setNombre(data.user.nombre);
				GConText.setType(data.user.type);
				GConText.setBookmark(data.user.bookmark);

				setLoginAttempts(0);
				setErrorLogin(false);

				// Redirección inmediata
				redirectUser(data.user.type);

			} else {
				// ❌ FALLBACK: Si el backend no devuelve perfil, usar método anterior
				sessionStorage.setItem('accessToken', data.accessToken);

				try {
					log('Obteniendo perfil por separado...');
					const perfil = await obtenerPerfil();

					GConText.setUserId(perfil.perfil.id);
					GConText.setNombre(perfil.perfil.nombre);
					GConText.setType(perfil.perfil.type);
					GConText.setBookmark(perfil.perfil.bookmark);

					setLoginAttempts(0);
					setErrorLogin(false);

					redirectUser(perfil.perfil.type);

				} catch (err) {
					console.error('Error obteniendo perfil:', err);
					sessionStorage.removeItem('accessToken');
					setErrorLogin(true);
					setErrorMessage('No se puede iniciar sesión, por favor verifica tu correo electrónico y contraseña.')
				}
			}

		} catch (err) {
			// ✨ Limpiar timeout en caso de error
			clearTimeout(timeoutId);
			console.timeEnd('🌐 Fetch request');
			console.timeEnd('⏱️ Login total');
			// ✨ Manejar error de timeout específicamente
			if (err.name === 'AbortError') {
				log('⏰ Login cancelado por timeout');
				//alert('La conexión está tardando demasiado. Intenta de nuevo.');

				setBlockMessage('La conexión está tardando demasiado. Intenta de nuevo.');
				setIsBlocked(true);
				setTimeout(() => {
					setIsBlocked(false);
					setBlockMessage('');
				}, 5000); // 5 segundos

			} else {
				logError('Error en login:', err);
			}

			setErrorLogin(true);
			setErrorMessage('No se puede iniciar sesión, por favor verifica tu correo electrónico y contraseña.')
			setLoginAttempts(loginAttempts + 1);
			//clearPass();
			setTimeoutImg();
		} finally {
			// ✨ Asegurar que el timeout se limpia siempre
			clearTimeout(timeoutId);
			setIsLoading(false);
		}
	};

	// 2FA verification
	const handleVerify2FA = async () => {
		setTwoFactorError('');
		setTwoFactorLoading(true);
		try {
			const res = await fetch(`${API_BASE}/verify-2fa`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ twoFactorKey, code: twoFactorCode }),
				credentials: 'include'
			});
			const data = await res.json();
			if (!res.ok) {
				setTwoFactorError(data.error || 'Código incorrecto');
				return;
			}
			// Login exitoso
			sessionStorage.setItem('accessToken', data.accessToken);
			if (data.user) {
				GConText.setUserId(data.user.id);
				GConText.setNombre(data.user.nombre);
				GConText.setType(data.user.type);
				GConText.setBookmark(data.user.bookmark);
				redirectUser(data.user.type);
			}
		} catch (err) {
			setTwoFactorError('Error de conexión. Intenta de nuevo.');
		} finally {
			setTwoFactorLoading(false);
		}
	};

	// Agregar estado para mostrar/ocultar password
	const [showPassword, setShowPassword] = useState(false);

	// Función para toggle
	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	/*
	  REGISTRO (v5)
	  - El flujo de registro se deja comentado por solicitud.
	  - Si se requiere reactivar, restaurar pestañas + estados + handleRegister.
	*/


	const [showForgotPassword, setShowForgotPassword] = useState(false);
	const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
	const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');
	const [forgotPasswordError, setForgotPasswordError] = useState('');

	const handleForgotPassword = async () => {
		setForgotPasswordError('');
		setForgotPasswordMessage('');

		if (!forgotPasswordEmail) {
			setForgotPasswordError('Ingresa tu correo electrónico');
			return;
		}

		try {
			const response = await fetch(`${API_BASE}/forgot-password`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email: forgotPasswordEmail })
			});

			if (response.ok) {
				setForgotPasswordMessage('Se ha enviado un enlace de recuperación a tu correo');
				setForgotPasswordEmail('');
			} else {
				setForgotPasswordError('No se encontró una cuenta con ese correo');
			}
		} catch (error) {
			setForgotPasswordError('Error de conexión. Intenta más tarde.');
		}
	};

	useEffect(() => {
		const checkAuthStatus = async () => {
			const token = sessionStorage.getItem('accessToken');

			if (token) {
				try {
					// Verificar si el token está expirado ANTES de hacer la llamada
					const payload = JSON.parse(atob(token.split('.')[1]));
					const now = Math.floor(Date.now() / 1000);

					if (payload.exp < now) {
						// Token expirado, limpiar
						if (GConText.logs) console.log('Token expirado, limpiando...');
						sessionStorage.removeItem('accessToken');

						// Intentar refresh si existe
						const refreshToken = localStorage.getItem('refreshToken');
						if (refreshToken) {
							const refreshSuccess = await refreshAccessToken();
							if (refreshSuccess) {
								const perfil = await obtenerPerfil();

								GConText.setUserId(perfil.perfil.id);
								GConText.setNombre(perfil.perfil.nombre);
								GConText.setType(perfil.perfil.type);
								GConText.setBookmark(perfil.perfil.bookmark);

								redirectUser(perfil.perfil.type);
								return;
							}
						}

						localStorage.removeItem('refreshToken');
						// ✨ AGREGAR ESTA LÍNEA - Mostrar login cuando no hay refresh o falló
						setIsCheckingAuth(false);
						return;
					}

					// Token válido, obtener perfil y redirigir
					const perfil = await obtenerPerfil();

					GConText.setUserId(perfil.perfil.id);
					GConText.setNombre(perfil.perfil.nombre);
					GConText.setType(perfil.perfil.type);
					GConText.setBookmark(perfil.perfil.bookmark);

					redirectUser(perfil.perfil.type);

				} catch (err) {
					// Token inválido, limpiar
					sessionStorage.removeItem('accessToken');
					localStorage.removeItem('refreshToken');
					// ✨ AGREGAR ESTA LÍNEA - Mostrar login cuando hay error
					setIsCheckingAuth(false);
				}
			} else {
				// ✨ No hay token, mostrar login inmediatamente
				setIsCheckingAuth(false);
			}
		};
		// ✨ Solo ejecutar UNA VEZ al montar el componente
		checkAuthStatus();
	}, [GConText, obtenerPerfil, redirectUser, refreshAccessToken]);

	if (isCheckingAuth) {
		return (
			<div className="container login-background" style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh'
			}}>
				<div style={{ textAlign: 'center', color: 'white' }}>
					<div className="spinner-border mb-3" role="status"></div>
					<div>Verificando sesión...</div>
				</div>
			</div>
		);
	}

		if (show2FA) {
		return (
			<div className="login-background" style={{ position: 'relative' }}>
				{/* Fondo con blur del login detrás */}
				<div style={{ position: 'absolute', inset: 0, backdropFilter: 'blur(8px)', background: 'rgba(0,0,0,0.5)' }} />
				<div style={{
					position: 'relative', zIndex: 10, background: '#fff', borderRadius: 20,
					padding: '48px 40px', maxWidth: 420, width: '90%', textAlign: 'center',
					boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
				}}>
					<img src={imgCorreo} alt="Correo" style={{ width: 56, marginBottom: 20 }} />
					<h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>Verifica tu correo</h2>
					<p style={{ fontSize: 18, color: '#666', marginBottom: 4 }}>Hemos enviado un código de 6 dígitos a</p>
					<p style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', marginBottom: 24 }}>{twoFactorEmail}</p>

					{twoFactorError && (
						<div className="error-message" style={{ marginBottom: 16 }}>{twoFactorError}</div>
					)}

					{/* 6 inputs individuales */}
					<div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 16 }}>
						{[0,1,2,3,4,5].map(i => (
							<input
								key={i}
								id={`code-${i}`}
								type="text"
								inputMode="numeric"
								maxLength={1}
								value={twoFactorCode[i] || ''}
								autoFocus={i === 0}
								onChange={(e) => {
									const val = e.target.value.replace(/\D/g, '');
									const newCode = twoFactorCode.split('');
									newCode[i] = val;
									setTwoFactorCode(newCode.join(''));
									if (val && i < 5) document.getElementById(`code-${i+1}`)?.focus();
								}}
								onKeyDown={(e) => {
									if (e.key === 'Backspace' && !twoFactorCode[i] && i > 0) {
										document.getElementById(`code-${i-1}`)?.focus();
									}
									if (e.key === 'Enter' && twoFactorCode.length === 6) handleVerify2FA();
								}}
								style={{
									width: 48, height: 56, textAlign: 'center', fontSize: 22, fontWeight: 700,
									border: '1px solid #e0e0e0', borderRadius: 10, background: '#f5f5f5', outline: 'none'
								}}
								onFocus={(e) => { e.target.style.borderColor = '#E40046'; }}
								onBlur={(e) => { e.target.style.borderColor = '#e0e0e0'; }}
							/>
						))}
					</div>

					<p style={{ fontSize: 18, color: '#999', marginBottom: 20 }}>Tienes 10 minutos para verificar</p>

					<button
						onClick={handleVerify2FA}
						className="btn-login"
						disabled={twoFactorCode.length !== 6 || twoFactorLoading}
					>
						{twoFactorLoading ? 'Verificando...' : 'Verificar código'}
					</button>

					<button
						onClick={() => { setShow2FA(false); setTwoFactorCode(''); setTwoFactorError(''); }}
						style={{ background: 'none', border: 'none', color: '#862633', fontWeight: 600, cursor: 'pointer', fontSize: 20, marginTop: 16 }}
					>
						Reenviar código
					</button>
				</div>
			</div>
		);
		}

		if (showResetPassword) {
		return <ResetPassword 
			token={resetToken}
			onBack={() => setShowResetPassword(false)}
		/>;
		}


	// Modificar el return del componente Login:
	return (
		
		<div className="login-background">
			<div className="login-layout">
				{/* Columna izquierda */}
				<div className="login-left">
					<div className="login-left__logos">
						<img src={imgLogoFemsa} alt="FEMSA" />
						<img src={imgLogoMirc} alt="MIRC" />
					</div>
					<h1 className="login-left__title">Manejo de Incidentes<br/>y Resolución de Crisis</h1>
					<div className="login-left__image">
						<img src={imgIlustracion} alt="Ilustración" />
					</div>
				</div>

				{/* Columna derecha - Card de login */}
				<div className="login-form">
					<h2 className="login-title">Bienvenido de nuevo</h2>
					<p className="login-subtitle">Ingresa tus datos para continuar</p>

					{/* Mensajes de error */}
					{(errorLogin || isBlocked) && (
						<div className="error-message">
							{errorMessage || blockMessage}
						</div>
					)}

					{/* Correo electrónico */}
					<div className="input-group">
						<label className="input-label">Correo electrónico</label>
						<div className="password-input-container">
							<span className="input-icon">
								<FontAwesomeIcon icon={faEnvelope} />
							</span>
							<input
								type="text"
								value={formData.username || ''}
								onChange={UserChange}
								ref={userInput}
								onKeyDown={handleKeyDown}
								className="form-control-login"
								placeholder="tu@correo.com"
							/>
						</div>
					</div>

					{/* Contraseña */}
					<div className="input-group">
						<label className="input-label">Contraseña</label>
						<div className="password-input-container">
							<span className="input-icon"><FontAwesomeIcon icon={faLock} /></span>
							<input
								type={showPassword ? 'text' : 'password'}
								value={formData.password || ''}
								onChange={PassChange}
								ref={passInput}
								onKeyDown={handleKeyDown}
								className="form-control-login"
								placeholder="••••••••"
							/>
							<button
								type="button"
								onClick={togglePasswordVisibility}
								className="password-toggle"
							>
								<FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
							</button>
						</div>
					</div>

					{/* Olvidaste contraseña */}
					<button
						type="button"
						onClick={() => setShowForgotPassword(true)}
						className="forgot-link"
					>
						¿Olvidaste tu contraseña?
					</button>

					{/* Botón login */}
					<button
						className="btn-login"
						onClick={chkLogin}
						disabled={isLoading || !isFormValid}
					>
						{isLoading ? (
							<>
								<FontAwesomeIcon icon={faSpinner} spin className="me-2" />
								Ingresando...
							</>
						) : (
							'Iniciar sesión'
						)}
					</button>
				</div>
			</div>

			{/* Footer */}
			<div className="login-footer">
				© 2026 Desarrollado por Intelego
			</div>

			{/* Modal de Recuperar Contraseña */}
			{showForgotPassword && (
				<div style={{
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backdropFilter: 'blur(8px)',
					background: 'rgba(0,0,0,0.5)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 1000
				}}>
					<div style={{
						backgroundColor: 'white',
						padding: '40px',
						borderRadius: '20px',
						maxWidth: '460px',
						width: '90%',
						boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
					}}>
						<h3 style={{ fontSize: 28, fontWeight: 700, marginBottom: 20 }}>Recupera tu contraseña</h3>

						{forgotPasswordMessage && (
							<div style={{ color: '#28a745', fontSize: 14, marginBottom: 15, padding: '10px 14px', background: '#d4edda', borderRadius: 8 }}>
								{forgotPasswordMessage}
							</div>
						)}

						{forgotPasswordError && (
							<div className="error-message">{forgotPasswordError}</div>
						)}

						<label style={{ fontSize: 16, fontWeight: 600, color: '#333', display: 'block', marginBottom: 6, textAlign: 'left' }}>Ingresa tu correo electrónico</label>
						<div className="password-input-container">
							<span className="input-icon"><FontAwesomeIcon icon={faEnvelope} /></span>
							<input
								type="email"
								value={forgotPasswordEmail}
								onChange={(e) => setForgotPasswordEmail(e.target.value)}
								placeholder="tu@correo.com"
								className="form-control-login"
							/>
						</div>

						<div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
							<button className='btn-cancel'
								onClick={() => {
									setShowForgotPassword(false);
									setForgotPasswordEmail('');
									setForgotPasswordMessage('');
									setForgotPasswordError('');
								}}
								/* style={{
									flex: 1,
									padding: '14px',
									border: '2px solid #E40046',
									borderRadius: 8,
									cursor: 'pointer',
									backgroundColor: 'white',
									color: '#E40046',
									fontWeight: 600,
									fontSize: 15
								}} */
							>
								Cancelar
							</button>
							<button
								onClick={handleForgotPassword}
								className="btn-login"
								/* style={{ flex: 1, margin: 0 }} */
							>
								Enviar correo
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Badge de versión */}
			<div className="version-badge">
				v{GConText.version}
			</div>
		</div>
	);

}
export default Login